import moment from 'moment';

// Single source of truth for the Meta-admin timestamp format. `MetaHealthCard`
// renders "Last verified" and `MetaConnectionDrawer` renders metrics-sync times
// with the same UTC formatting — keep them in lockstep here.
export function formatUtcTimestamp(iso: string): string {
	const m = moment(iso);
	return m.isValid() ? m.utc().format('YYYY-MM-DD HH:mm [UTC]') : iso;
}

// webServiceHelper.callAsync rejects with `{ systemMessage, systemCode? }`,
// not an Error instance. This shared helper pulls a human-readable string out of
// whatever shape the rejection happens to take.
export function getErrorMessage(error: unknown): string | null {
	if (!error) return null;
	if (typeof error === 'string') return error;
	if (typeof error === 'object') {
		const maybe = error as { systemMessage?: unknown; message?: unknown };
		if (typeof maybe.systemMessage === 'string') return maybe.systemMessage;
		if (typeof maybe.message === 'string') return maybe.message;
	}
	return null;
}

// Translate the semantic tone on META_AD_ACCOUNT_STATUS_LABELS to a `Pill`
// color key. Centralized so the table and drawer can't drift.
type StatusTone = 'success' | 'warning' | 'danger' | 'neutral';
type StatusPillColor = 'green' | 'orange' | 'red' | 'gray';

export function tonePillColor(tone: StatusTone): StatusPillColor {
	switch (tone) {
		case 'success':
			return 'green';
		case 'warning':
			return 'orange';
		case 'danger':
			return 'red';
		case 'neutral':
		default:
			return 'gray';
	}
}
